.dialogBody {
  display: flex;
}

.dialogContent {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;
}
.dialogContent textarea {
  font-family: "monospace";
  flex-grow: 1;
}